import React from "react"

export default function Home() {
  return <div>Hello world! This is the beginning of a new adventure</div>
}
